var searchHandleBarsTemplate = null;
var itemsPerPage = 30;
var SearchType = "";
var initialSearch = true;
var searchParams = null;
//var newsRootId = 0;
var filterClicked = false;
var versionNo = 2;

function initHandleBarsHelpers() {
    Handlebars.registerHelper("formatDate", function (datetime, format) {
        if (moment) {
            return moment(datetime).format(format);
        } else {
            return datetime;
        }
    });
    Handlebars.registerHelper('if_1900', function (a, opts) {
        var dateObj = moment(a);
        if (dateObj.year() === 1900) {
            return opts.inverse(this);
        } else {
            return opts.fn(this);
        }
    });
    Handlebars.registerHelper('if_eq', function (a, b, opts) {
        if (a === b) {
            return opts.fn(this);
        } else {
            return opts.inverse(this);
        }
    });
}

// Init - Called from the script Utils.AddScript() tag in the template
function initSiteSearchHandleBars(hasSearchTerm) {
    if (hasSearchTerm === true) {
        initialSearch = false;  // Prevent a keyword from the query string from being overwritten
    }

    SearchType = "SiteSearch";
    initHandleBarsHelpers();

    // Init handlebars and get the results
    var source = document.getElementById("searchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);
    var prom = GetSearchResults(1);
    prom.then(
        function (result) {
            //console.log("Search results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            $('#pagination_search').pagination({
                items: result.totalResultCount,
                itemsOnPage: itemsPerPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber, event) {
                    //console.log('page %o, contents : %o', pageNumber, event);
                    DoAjaxSearch(pageNumber);
                    scrollToAnchorOffset('#topOfSearch', -120);
                },
                onInit: function () {
                    //console.log('Init paging');
                    var resultCount = 0;
                    if (result.totalResultCount !== null) {
                        resultCount = result.totalResultCount;
                    }
                    doPagination(resultCount, 1);
                }
            });
        }
    );

    $('#searchboxSite').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            DoAjaxSearch(1);
        }
    });

    // Add events for checkboxes
    $(".search__aggregation input[type='checkbox']").click(function () {
        //console.log("Checkbox clicked");
        DoAjaxSearch(1);
    });
}
function initCharitySiteSearchHandleBars(hasSearchTerm) {
    if (hasSearchTerm === true) {
        initialSearch = false;  // Prevent a keyword from the query string from being overwritten
    }

    SearchType = "CharitySiteSearch";
    initHandleBarsHelpers();

    // Init handlebars and get the results
    var source = document.getElementById("searchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);
    var prom = GetSearchResults(1);
    prom.then(
        function (result) {
            console.log("Search results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            $('#pagination_search').pagination({
                items: result.totalResultCount,
                itemsOnPage: itemsPerPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber, event) {
                    //console.log('page %o, contents : %o', pageNumber, event);
                    DoAjaxSearch(pageNumber);
                    scrollToAnchorOffset('#topOfSearch', -120);
                },
                onInit: function () {
                    //console.log('Init paging');
                    var resultCount = 0;
                    if (result.totalResultCount !== null) {
                        resultCount = result.totalResultCount;
                    }
                    doPagination(resultCount, 1);
                }
            });
        }
    );

    $('#searchboxSite').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            DoAjaxSearch(1);
        }
    });

    // Add events for checkboxes
    $(".search__aggregation input[type='checkbox']").click(function () {
        //console.log("Checkbox clicked");
        DoAjaxSearch(1);
    });
}
function initPublicationHandleBars() {
    SearchType = "PublicationSearch";
    initHandleBarsHelpers();

    // Init date range picker
    $('#dateRangePicker').datepicker({
        language: 'en',
        range: true,
        dateFormat: 'M yyyy',
        multipleDatesSeparator: " - ",
        autoClose: true,
        view: "months",
        minView: "months",
        onSelect: function (formattedDate, date, inst) {
            //console.log('on select : %o, %o, %o', formattedDate, date, inst);
            if (date.length > 1) {
                //"YYYYMMDDHHmmssSSS"
                var startString = moment(date[0]).format();
                // Only picking month so go to the end of both the days (month) and hours (days)
                var endString = moment(date[1]).endOf('month').endOf('day').endOf('hour').endOf('minute').endOf('second').format();
                //console.log('Got dates : %o, %o', startString , endString );

                $('#startDate').val(startString);
                $('#endDate').val(endString);

                // Fire the search
                if (!initialSearch) {
                    var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
                    datepicker.hide();
                    DoAjaxSearch(1);
                }
            }
        }
    });
    $("#dateRangePicker").attr("autocomplete", "off");

    // Init handlebars and get the results
    var source = document.getElementById("searchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);
    var rootNode = $('#rootNode').val();
    var prom = GetSearchResults(1, rootNode);
    prom.then(
        function (result) {
            console.log("Search results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            $('#pagination_search').pagination({
                items: result.totalResultCount,
                itemsOnPage: itemsPerPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber, event) {
                    //console.log('page %o, contents : %o', pageNumber, event);
                    DoAjaxSearch(pageNumber);
                },
                onInit: function () {
                    //console.log('Init paging');
                    //doPagination(result.results.length, 1);
                }
            });
        }
    );

    $('#searchboxSite').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            DoAjaxSearch(1);
        }
    });

    // Add events for checkboxes
    $(".search__aggregation input[type='checkbox']").click(function () {
        DoAjaxSearch(1);
    });
}
function initEventsHandleBars(newsRoot) {
    var calendarEl = document.getElementById('calendar');
    var events = [];

    //console.log("I am here updated2");
    //newsRootId = newsRoot;
    SearchType = "NewsSearch";
    initHandleBarsHelpers();

    // Init date range picker
    $('#dateRangePicker').datepicker({
        language: 'en',
        range: true,
        dateFormat: 'M yyyy',
        multipleDatesSeparator: " - ",
        autoClose: true,
        view: "months",
        minView: "months",
        onSelect: function (formattedDate, date, inst) {
            //console.log('on select : %o, %o, %o', formattedDate, date, inst);
            if (date.length > 1) {
                //"YYYYMMDDHHmmssSSS"
                var startString = moment(date[0]).format();
                // Only picking month so go to the end of both the days (month) and hours (days)
                var endString = moment(date[1]).endOf('month').endOf('day').endOf('hour').endOf('minute').endOf('second').format();
                //console.log('Got dates : %o, %o', startString , endString );

                $('#startDate').val(startString);
                $('#endDate').val(endString);

                // Fire the search
                if (!initialSearch) {
                    var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
                    datepicker.hide();
                    DoAjaxSearch(1);
                }
            }
        }
    });
    $("#dateRangePicker").attr("autocomplete", "off");

    // Init handlebars and get the results
    var source = document.getElementById("searchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);
    var prom = GetSearchResults(1, newsRoot);
    prom.then(
        function (result) {
            console.log("Search results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);
            $(result.results).each(function (index, eventItem) {
                events.push({
                    "title": eventItem.Name,
                    "start": eventItem.EventDate
                });
            });
            var calendar = new FullCalendar.Calendar(calendarEl, {
                initialView: 'dayGridMonth',
                events: events,
            });
            calendar.render();

            $('#pagination_search').pagination({
                items: result.totalResultCount,
                itemsOnPage: itemsPerPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber, event) {
                    //console.log('page %o, contents : %o', pageNumber, event);
                    DoAjaxSearch(pageNumber);
                },
                onInit: function () {
                    //console.log('Init paging');
                    //doPagination(result.results.length, 1);
                }
            });
        }
    );

    // Catch enter key on search box
    $('#searchboxSite').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            DoAjaxSearch(1);
        }
    });
    $(".search__aggregation input[type='checkbox']").click(function () {
        //console.log("Checkbox clicked");
        filterClicked = true;
        DoAjaxSearch(1);
    });
}
function initNewsHandleBars(newsRoot) {
    //console.log("I am here updated2");
    //newsRootId = newsRoot;
    SearchType = "NewsSearch";
    initHandleBarsHelpers();

    // Init date range picker
    $('#dateRangePicker').datepicker({
        language: 'en',
        range: true,
        dateFormat: 'M yyyy',
        multipleDatesSeparator: " - ",
        autoClose: true,
        view: "months",
        minView: "months",
        onSelect: function (formattedDate, date, inst) {
            //console.log('on select : %o, %o, %o', formattedDate, date, inst);
            if (date.length > 1) {
                //"YYYYMMDDHHmmssSSS"
                var startString = moment(date[0]).format();
                // Only picking month so go to the end of both the days (month) and hours (days)
                var endString = moment(date[1]).endOf('month').endOf('day').endOf('hour').endOf('minute').endOf('second').format();
                //console.log('Got dates : %o, %o', startString , endString );

                $('#startDate').val(startString);
                $('#endDate').val(endString);

                // Fire the search
                if (!initialSearch) {
                    var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
                    datepicker.hide();
                    DoAjaxSearch(1);
                }
            }
        }
    });
    $("#dateRangePicker").attr("autocomplete", "off");

    // Init handlebars and get the results
    var source = document.getElementById("searchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);
    var prom = GetSearchResults(1, newsRoot);
    prom.then(
        function (result) {
            console.log("Search results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);
            //console.log("I am here");

            $('#pagination_search').pagination({
                items: result.totalResultCount,
                itemsOnPage: itemsPerPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber, event) {
                    //console.log('page %o, contents : %o', pageNumber, event);
                    DoAjaxSearch(pageNumber);
                },
                onInit: function () {
                    //console.log('Init paging');
                    //doPagination(result.results.length, 1);
                }
            });
        }
    );

    // Catch enter key on search box
    $('#searchboxSite').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            DoAjaxSearch(1);
        }
    });
    $(".search__aggregation input[type='checkbox']").click(function () {
        //console.log("Checkbox clicked");
        filterClicked = true;
        DoAjaxSearch(1);
    });
}
function initCaseStudyHandleBars(csRoot) {
    //newsRootId = newsRoot;
    SearchType = "CaseStudySearch";
    initHandleBarsHelpers();

    // Init date range picker
    $('#dateRangePicker').datepicker({
        language: 'en',
        range: true,
        dateFormat: 'M yyyy',
        multipleDatesSeparator: " - ",
        autoClose: true,
        view: "months",
        minView: "months",
        onSelect: function (formattedDate, date, inst) {
            //console.log('on select : %o, %o, %o', formattedDate, date, inst);
            if (date.length > 1) {
                //"YYYYMMDDHHmmssSSS"
                var startString = moment(date[0]).format();
                // Only picking month so go to the end of both the days (month) and hours (days)
                var endString = moment(date[1]).endOf('month').endOf('day').endOf('hour').endOf('minute').endOf('second').format();
                //console.log('Got dates : %o, %o', startString , endString );

                $('#startDate').val(startString);
                $('#endDate').val(endString);

                // Fire the search
                if (!initialSearch) {
                    var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
                    datepicker.hide();
                    DoAjaxSearch(1);
                }
            }
        }
    });
    $("#dateRangePicker").attr("autocomplete", "off");

    // Init handlebars and get the results
    var source = document.getElementById("searchTemplate").innerHTML;
    searchHandleBarsTemplate = Handlebars.compile(source);
    var prom = GetSearchResults(1, csRoot);
    prom.then(
        function (result) {
            console.log("Search results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            $('#pagination_search').pagination({
                items: result.totalResultCount,
                itemsOnPage: itemsPerPage,
                cssStyle: 'light-theme',
                onPageClick: function (pageNumber, event) {
                    //console.log('page %o, contents : %o', pageNumber, event);
                    DoAjaxSearch(pageNumber);
                },
                onInit: function () {
                    //console.log('Init paging');
                    //doPagination(result.results.length, 1);
                }
            });
        }
    );

    // Catch enter key on search box
    $('#searchboxSite').keypress(function (event) {
        var keycode = event.keyCode ? event.keyCode : event.which;
        if (keycode === '13') {
            DoAjaxSearch(1);
        }
    });
    $(".search__aggregation input[type='checkbox']").click(function () {
        //console.log("Checkbox clicked");
        filterClicked = true;
        DoAjaxSearch(1);
    });
}

function clearPublicationSearch() {
    $('.search__aggregation input[type=checkbox]').prop('checked', '');

    var datepicker = $('#dateRangePicker').datepicker().data('datepicker');

    datepicker.clear();
    $('#startDate').val('');
    $('#endDate').val('');

    DoAjaxSearch(1);
}
function clearNewsSearch() {

    // Clear text input
    document.getElementById('searchboxSite').value = '';

    // Clear date range inputs
    document.getElementById('dateRangePicker').value = '';
    document.getElementById('startDate').value = '';
    document.getElementById('endDate').value = '';

    DoAjaxSearch(1);
}
function clearSiteSearch() {

    // Uncheck all the boxes
    $('.search__aggregation input[type=checkbox]').prop('checked', '');

    // Recheck the Content type boxes
    $('.search__aggregation input[type=checkbox][data-group="ContentType"]').prop('checked', 'checked');

    DoAjaxSearch(1);
}
function clearCharitySiteSearch() {

    // Clear text input
    document.getElementById('searchboxSite').value = '';

    // Clear date range inputs
    document.getElementById('dateRangePicker').value = '';
    document.getElementById('startDate').value = '';
    document.getElementById('endDate').value = '';


    DoAjaxSearch(1);
}

// The following groups are called by convention using searchType  e.g. 'populate' + SearchType + '()'
function populatePublicationSearch(fieldsObj) {
    //console.log('Populate form from cookie object : %o', fieldsObj);
    $('#searchboxSite').val(fieldsObj.keywords);

    if (typeof fieldsObj["startDate"] !== 'undefined' && typeof fieldsObj["endDate"] !== undefined) {
        var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
        var dates = [moment(fieldsObj.startDate).toDate(), moment(fieldsObj.endDate).toDate()];
        //console.log(dates);
        datepicker.selectDate(dates);
    }

    checkBoxesByValue(fieldsObj.publicationType);
}
function populateNewsSearch(fieldsObj) {
    //console.log('Populate form from cookie object : %o', fieldsObj);
    $('#searchboxSite').val(fieldsObj.keywords);

    if (typeof fieldsObj["startDate"] !== 'undefined' && typeof fieldsObj["endDate"] !== undefined) {
        var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
        var dates = [moment(fieldsObj.startDate).toDate(), moment(fieldsObj.endDate).toDate()];
        //console.log(dates);
        datepicker.selectDate(dates);
    }
}
function populateSiteSearch(fieldsObj) {
    //console.log('Populate form from cookie object : %o', fieldsObj);
    $('#searchboxSite').val(fieldsObj.keywords);

    // Checked by default so in this case we need to disable all then apply the saved ones
    $('input[type=checkbox][data-group="ContentType"]').prop('checked', '');

    //console.log("Content type : %o", fieldsObj.contentType[5]);
    if (fieldsObj.contentType[5] === "gatewayPage standardContentPage homePageCampaign") {
        //console.log("Fixed old content type");
        fieldsObj.contentType[5] = "gatewayPage standardContentPage homePageCampaign charityGatewayPage charityHomepage charityStandardContentPage";
    }

    checkBoxesByValue(fieldsObj.contentType);
    checkBoxesByValue(fieldsObj.audience);
    checkBoxesByValue(fieldsObj.health);
    checkBoxesByValue(fieldsObj.services);
}
function populateCaseStudySearch(fieldsObj) {
    //console.log('Populate form from cookie object : %o', fieldsObj);
    $('#searchboxSite').val(fieldsObj.keywords);

    if (typeof fieldsObj["startDate"] !== 'undefined' && typeof fieldsObj["endDate"] !== undefined) {
        var datepicker = $('#dateRangePicker').datepicker().data('datepicker');
        var dates = [moment(fieldsObj.startDate).toDate(), moment(fieldsObj.endDate).toDate()];
        //console.log(dates);
        datepicker.selectDate(dates);
    }
}
function populateCharitySiteSearch(fieldsObj) {
    //console.log('Populate charity site search : %o', fieldsObj);
    $('#searchboxSite').val(fieldsObj.keywords);
}

// Takes an array of values and checks the corresponding boxes
function checkBoxesByValue(arrayOfValues) {
    if (typeof arrayOfValues !== 'undefined') {
        if (arrayOfValues.length > 0) {
            for (var i = 0; i < arrayOfValues.length; i++) {
                $('input[type=checkbox][value="' + arrayOfValues[i] + '"]').prop('checked', 'checked');
            }
        }
    }
}
// Some boxes are ticked by default and we need to untick
function uncheckBoxesByValue(arrayOfValues) {
    if (typeof arrayOfValues !== 'undefined') {
        if (arrayOfValues.length > 0) {
            for (var i = 0; i < arrayOfValues.length; i++) {
                $('input[type=checkbox][value="' + arrayOfValues[i] + '"]').prop('checked', 'checked');
            }
        }
    }
}

function doPagination(resultCount, currentPage) {
    var $pagination = $('#pagination_search');

    //console.log('Page results count : %o' , resultCount);

    if (resultCount !== null && resultCount > itemsPerPage) {
        $pagination.pagination('destroy');
        $pagination.pagination('updateItems', resultCount);
        $pagination.pagination('drawPage', currentPage);
        $pagination.show();
    } else {
        $pagination.hide();
    }
}

function DoAjaxSearch(pageNo) {
    var prom = GetSearchResults(pageNo);
    prom.then(
        function (result) {
            //console.log("Processing ajax results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            doPagination(result.totalResultCount, pageNo);

            // Order by drop down
            var selector = '#orderField option[value=' + searchParams.orderField + ']';
            $(selector).attr('selected', 'selected');
        }
    );
}
function DoAjaxSearchCharity(pageNo) {
    var prom = GetSearchResults(pageNo);
    prom.then(
        function (result) {
            //console.log("Processing ajax results : %o", result);

            var html = searchHandleBarsTemplate(result);
            $('#search__results').html(html);

            doPagination(result.totalResultCount, pageNo);

            // Order by drop down
            var selector = '#orderField option[value=' + searchParams.orderField + ']';
            $(selector).attr('selected', 'selected');
        }
    );
}

// Do our ajax call to fetch the results
function GetSearchResults(pageNo, rootNode) {
    return new Promise(function (resolve, reject) {
        //var searchParams = null;
        var paramSource = "";

        // If we have a cookie use that object to search and populate the form
        if (initialSearch && Cookies.get(SearchType)) {
            // Get from cookie
            paramSource = "cookie";
            searchParams = JSON.parse(Cookies.get(SearchType));

            if (searchParams.versionNo != versionNo) {
                // Remove all the settings
                console.log('Clear all checkboxes');
                paramSource = "fields";
                searchParams = buildSiteSearchParams(pageNo, versionNo);
            } else {
                // default
                searchParams.rootNodeId = rootNode;
                var fn = window['populate' + SearchType];
                if (typeof fn === "function") {
                    fn(searchParams);
                } else {
                    console.error('Missing populate function %o so can\'t populate form', 'populate' + SearchType);
                }
            }
        } else {
            // Default
            paramSource = "fields";
            searchParams = buildSiteSearchParams(pageNo, versionNo);
        }

        //console.log('GetSearchResults from %o searchParams : %o', paramSource, searchParams);
        initialSearch = false;
        $.ajax({
            url: "/Umbraco/Surface/NHSSiteSearch/DoSiteSearchJSON",
            method: 'post',
            data: searchParams
        }).done(function (result) {
            //console.log('done ', result);
            resolve(result);
        }).fail(function (result) {
            console.log('Failed', result);
            reject(result);
        });
    });
}

function filterToArray(collection) {
    var result = new Array();
    var length = collection.length;

    for (var j = 0; j < length; j++) {
        result.push($(collection[j]).val());
    }

    return result;
}

function isEmptyOrSpaces(str) {
    if (str === undefined) { return true; }
    return str === null || str.match(/^ *$/) !== null;
}

function buildSiteSearchParams(pageNo, versionNo) {
    searchParams = {};
    searchParams.resultPage = pageNo;

    searchParams.versionNo = 0;
    if (versionNo !== '') {
        searchParams.versionNo = versionNo;
    }

    // Keywords
    if ($('#searchboxSite').val() !== '') {
        searchParams.keywords = $('#searchboxSite').val();
    }

    // content type : "content" or "media"  - (empty = both)
    if ($('#searchContentType').val() !== null && $('#searchContentType').val() !== '') {
        searchParams.contentTypeCorM = $('#searchContentType').val();
    }

    // Root node restriction . e.g. publications only look in the archive folder
    var rnv = $('#rootNode').val();
    if (rnv !== null && rnv !== '' && rnv !== undefined) {
        searchParams.rootNodeId = $('#rootNode').val();
    }

    // Date filter target field
    if ($('#dateFilterField').val() !== null && $('#dateFilterField').val() !== '') {
        searchParams.dateFilterField = $('#dateFilterField').val();
    }

    // Results order
    if ($('#orderField').val() !== null && $('#orderField').val() !== '') {
        searchParams.orderField = $('#orderField').val();
    }

    // Services
    var checks = $("input[type='checkbox']:checked[data-group='Service types']");
    if (checks.length) {
        searchParams.services = filterToArray(checks);
    }

    // Health topic
    checks = $("input[type='checkbox']:checked[data-group='Health Topic']");
    if (checks.length) {
        searchParams.health = filterToArray(checks);
    }

    // Audience
    checks = $("input[type='checkbox']:checked[data-group='Audience']");
    if (checks.length) {
        searchParams.audience = filterToArray(checks);
    }

    // Content type
    checks = $("input[type='checkbox']:checked[data-group='ContentType']");
    if (checks.length) {
        searchParams.contentType = filterToArray(checks);
    }

    // Publication Types
    checks = $("input[type='checkbox']:checked[data-group='pubTypes']");
    if (checks.length) {
        searchParams.publicationType = filterToArray(checks);
    }

    // News types
    checks = $("input[type='checkbox']:checked[data-group='NewsType']");
    if (checks.length) {
        searchParams.newsType = filterToArray(checks);
        searchParams.isNews = true;
        //searchParams.SearchType = "News Search";
    } else {
        searchParams.newsType = [];
        searchParams.isNews = true;
        //searchParams.SearchType = "News Search";
    }
    filterClicked = false;

    // No checkboxes but news type is specified in a hidden field
    if (searchParams.newsType.length == 0) {
        checks = $("#newsTags").val();
        if (checks !== null && checks !== undefined && checks !== 'undefined') {
            var checkArray = checks.split(",");

            //console.log("News checks: %o", checkArray);
            if (checks.length) {
                searchParams.newsType = checkArray;
                searchParams.isNews = true;
                searchParams.SearchType = "News Search";
            }
        }
    }

    //console.log()
    if (!isEmptyOrSpaces($('#startDate').val()) && !isEmptyOrSpaces($('#endDate').val())) {
        searchParams.startDate = $('#startDate').val();
        searchParams.endDate = $('#endDate').val();
    }

    // Save a cookie
    if (SearchType === "" || SearchType === "NewsSearch") {
        console.log('Search type not set so no cookie name available');
    } else {
        //console.log('Setting %o cookie to %o', SearchType, searchParams);
        Cookies.set(SearchType, JSON.stringify(searchParams), {
            //expires: 1 - Session cookie
        });
    }
    searchParams.searchPage = window.location.pathname;
    //console.log('search params : %o', searchParams);
    return searchParams;
}